import { Link } from 'react-router-dom';

export default function AboutSpreadsheet() {
  return (
    <section id="guides" className="py-16 md:py-24 bg-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center mb-16">
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-900 mb-6">
            What Is Superbuy Spreadsheet?
          </h2>
          <div className="text-sm md:text-base text-foreground-600 leading-relaxed space-y-4">
            <p>
              A <strong>Superbuy Spreadsheet</strong> is a meticulously organized digital document that serves
              as a centralized product discovery hub for international shoppers. Rather than spending countless
              hours browsing scattered product listings across different platforms, users access a single,
              well-structured spreadsheet containing direct links to vetted products organized by category,
              price range, and quality indicators.
            </p>
            <p>
              The concept emerged from the growing community of savvy international shoppers who realized that
              sharing curated product finds through spreadsheets dramatically reduced research time and improved
              purchasing confidence. Each entry in a Superbuy Spreadsheet typically includes the product name,
              direct purchase link, price information, sizing notes, QC (Quality Check) photo references, and
              community feedback — creating a comprehensive shopping companion that transforms how people discover
              and evaluate products online.
            </p>
            <p>
              Modern Superbuy Spreadsheets have evolved far beyond simple product lists. Today&apos;s versions
              incorporate advanced features such as automated price tracking, community voting systems, seasonal
              trend categorization, and integrated safety verification tools. Whether you&apos;re searching for
              the latest sneaker releases, trending fashion pieces, or everyday essentials, a well-maintained
              Superbuy Spreadsheet eliminates the guesswork from international shopping and connects you directly
              with trusted products that the community has already validated.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {[
            {
              icon: 'ri-layout-grid-line',
              title: 'Organized Product Discovery',
              desc: 'Find categorized products quickly with structured data fields and intuitive navigation systems.',
            },
            {
              icon: 'ri-scales-3-line',
              title: 'Smart Comparison Tools',
              desc: 'Compare pricing, quality indicators, and community ratings before making purchase decisions.',
            },
            {
              icon: 'ri-zoom-in-line',
              title: 'QC Knowledge Center',
              desc: 'Access detailed quality checking guides, photo analysis tutorials, and inspection criteria.',
            },
            {
              icon: 'ri-shield-star-line',
              title: 'Safety First Approach',
              desc: 'Learn safer shopping practices with verified links, seller vetting, and payment protection tips.',
            },
          ].map((feature, idx) => (
            <div
              key={idx}
              className="p-6 rounded-lg bg-background-100 hover:bg-background-200/70 transition-colors"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-100 mb-4">
                <i className={`${feature.icon} text-accent-600 text-xl`}></i>
              </div>
              <h3 className="font-semibold text-sm text-foreground-900 mb-2">{feature.title}</h3>
              <p className="text-xs text-foreground-500 leading-relaxed">{feature.desc}</p>
            </div>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/superbuy-spreadsheet-beginner-guide"
            className="inline-flex items-center gap-2 px-6 py-2.5 rounded-full bg-accent-500 text-background-50 text-sm font-semibold whitespace-nowrap cursor-pointer hover:bg-accent-600 transition-all"
          >
            Start Beginner Guide
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}